/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const CompareResize = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domCompareItemTitleWrap: $('.compare__items-item-wrapper--title'),
	$domCompareItemList: $('.compare__items-item-wrapper--list'),
	$domCompareCategoriesTitleWrap: $('.compare__categories-title-wrapper--title'),
	$domCompareCategoriesDetailsWrap: $('.compare__categories-title-wrapper--details'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */

	init: function() {
		this.resize();
	},

	resize: function() {
		$(window).on('load', () => {
			const ItemTitleSize = CompareResize.$domCompareItemTitleWrap.height();
			const ItemDetailsListSize = CompareResize.$domCompareItemList.height();
			CompareResize.$domCompareCategoriesTitleWrap.height(ItemTitleSize);
			CompareResize.$domCompareCategoriesDetailsWrap.height(ItemDetailsListSize);
		});
	}
};

export default CompareResize;
